/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import Form from 'react-bootstrap/Form';
import { MenuItem } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  getCheckBoxValue,
  getRebateProgrameList,
  getQuarterValue,
  getCmsMismatchDetails,
  dispatchCheckedValueCMS,
  dispatchErrorMsg,
  dispatchSearchData,
  dispatchCmsMismatchDetailTabData,
} from '../store/actions';
import {
  INVOICED,
  navigate,
  NON_INVOICED,
  PLAN_TYPE,
  QUARTER,
  REBATE_PROGRAM,
} from './ConstantData';
import {
  MNFC_NDC_ERROR_MSG,
  MUST_CHECK_ANY_CHECKBOX,
  QUARTER_VALUE_REQUIRED,
  REBATE_PROGRAM_REQUIRED,
  VALIDATE_QUARTER_VALUE,
  STATUS_MSG,
  SUCCESS_MSG,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  handleScrollToEvent,
  quarterTest1,
  quarterTest2,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';

const CmsMismatch = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function
  const planTypeList = useSelector(
    (state) => state?.sharedState?.CMSMismatchReducer?.planType
  );
  const getCheckedValue = useSelector(
    (state) => state?.sharedState?.CMSMismatchReducer?.checkedValue
  );
  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.CMSMismatchReducer?.errorMsgCmsMiss
  );
  const getRebateProgramList = useSelector(
    (state) => state?.sharedState?.CMSMismatchReducer?.rebateProgram
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const searchCmsMismatchData = useSelector(
    (state) => state?.sharedState?.CMSMismatchReducer?.searchScreenData
  );
  const getQuarterDataValue = useSelector(
    (state) => state?.sharedState?.CMSMismatchReducer?.quarter
  );
  // variable deceleration
  const [searchData, setSearchData] = useState(
    searchCmsMismatchData?.searchData
      ? searchCmsMismatchData?.searchData
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
          quarterValue: null,
        }
  );
  const [radioList, setRadioList] = useState([]);
  const [checkValue, setCheckValue] = useState();
  const [loading, setLoading] = useState(false);
  const [rebateProgramList, setRebateProgramList] = useState([]);
  const [rebateProList, setRebateProList] = useState([]);
  // checkValue useEffect
  React.useEffect(() => {
    if (getCheckedValue) {
      setCheckValue(getCheckedValue);
    }
  }, [getCheckedValue]);
  //  get quarter value useEffect
  React.useEffect(() => {
    if (_.isEmpty(getQuarterDataValue)) {
      dispatch(getQuarterValue());
    }
  }, []);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  // setting quarter value
  React.useEffect(() => {
    let quarter = '';
    if (
      getQuarterDataValue?.status === STATUS_MSG &&
      getQuarterDataValue?.message === SUCCESS_MSG
    ) {
      const receivedQuarter =
        getQuarterDataValue?.cmsMisMatchQtrResponseVO?.qtr;
      if (receivedQuarter) {
        quarter = receivedQuarter;
      }
    }
    if (_.isEmpty(searchCmsMismatchData?.searchData?.quarterValue)) {
      setSearchData({ ...searchData, quarterValue: quarter });
      setSearchCmsMismatch({
        searchData: { ...searchData, quarterValue: quarter },
      });
    }
  }, [getQuarterDataValue]);
  // Plan type useEffect
  React.useEffect(() => {
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getCheckBoxValue({}));
    }
  }, []);
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    if (searchData.planTypeCd) {
      getRebateProgrameList(searchData.planTypeCd).then((res) => {
        setRebateProList(res);
      });
    }
  }, [searchData.planTypeCd]);
  // set Rebate Program List
  React.useEffect(() => {
    let list = [];
    if (
      rebateProList?.status === STATUS_MSG &&
      rebateProList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(rebateProList.data)) {
        list = _.map(rebateProList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [rebateProList]);
  // dispatch function
  const setSearchCmsMismatch = (value) => dispatch(dispatchSearchData(value));
  //   change plan type function
  const handleOnChangeEvent = (value, name) => {
    if (name === 'planTypeCd') {
      setSearchData({ ...searchData, [name]: value, rebateProgramCd: '-1' });
      setSearchCmsMismatch({
        searchData: { ...searchData, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setSearchData({ ...searchData, [name]: value });
      setSearchCmsMismatch({
        searchData: { ...searchData, [name]: value },
      });
    }
    if (name === 'quarterValue') {
      setSearchData({ ...searchData, [name]: value });
      setSearchCmsMismatch({
        searchData: { ...searchData, [name]: value },
      });
    }
  };
  // onclick functionality on View CMS Mismatch Detail button
  const clickHandlerOnProcess = async () => {
    let arr = [];
    if (searchData?.rebateProgramCd !== '-1') {
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, {
            field: 'rebateProgramCd',
            errorType: 'required',
          })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }
    } else {
      arr.push({
        field: 'rebateProgramCd',
        errorType: 'required',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    if (
      searchData?.quarterValue &&
      !_.isEmpty(searchData?.quarterValue) &&
      !_.isNaN(searchData?.quarterValue)
    ) {
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, {
            field: 'quarter',
            errorType: 'required',
          })
        : null;

      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }
      if (
        quarterTest1.test(searchData?.quarterValue) ||
        quarterTest2.test(searchData?.quarterValue)
      ) {
        const indexOf = !_.isEmpty(arr)
          ? _.findIndex(arr, {
              field: 'quarter',
              errorType: 'invalidFormat',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          arr.splice(indexOf, 1);
        }
        arr = arr.filter((item) => item.field !== 'quarter');
        setSearchData({
          ...searchData,
          quarterValue: autoFormateDate(
            searchData?.quarterValue?.toUpperCase()
          ),
        });
        setSearchCmsMismatch({
          searchData: {
            ...searchData,
            quarterValue: autoFormateDate(
              searchData?.quarterValue?.toUpperCase()
            ),
          },
        });
      } else {
        arr = arr.filter((item) => item.field !== 'quarter');
        arr.push({
          field: 'quarter',
          errorType: 'invalidFormat',
          message: VALIDATE_QUARTER_VALUE,
        });
      }
    } else {
      arr = arr.filter((item) => item.field !== 'quarter');
      arr.push({
        field: 'quarter',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    if (!(checkValue?.invoiced === 1) && !(checkValue?.nonInvoiced === 1)) {
      arr = arr.filter((item) => item.errorType !== 'checkboxisnotchecked');
      arr.push({
        field: 'checkbox',
        errorType: 'checkboxisnotchecked',
        message: MUST_CHECK_ANY_CHECKBOX,
      });
    } else {
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, {
            field: 'checkbox',
            errorType: 'checkboxisnotchecked',
          })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }
    }
    if (
      (checkValue?.invoiced === 1 || checkValue?.nonInvoiced === 1) &&
      searchData?.rebateProgramCd !== '-1' &&
      searchData?.quarterValue !== ''
    ) {
      setLoading(true);
      const result = await dispatch(
        getCmsMismatchDetails({
          rebateProgramCd: searchData?.rebateProgramCd,
          dramsQtr: searchData?.quarterValue,
          invoiced: checkValue?.invoiced,
          nonInvoiced: checkValue?.nonInvoiced,
        })
      );
      const response = result && result.payload;
      if (
        response &&
        response.cmsMisMatchDetailResponseVO &&
        response.cmsMisMatchDetailResponseVO.length > 0
      ) {
        tabHighLigther(navigate, false);
        const Obj = {};
        Obj.searchData = searchData;
        Obj.rebateProgramCd = searchData?.rebateProgramCd;
        Obj.checkValue = getCheckedValue;
        dispatch(dispatchCmsMismatchDetailTabData(Obj));
        redirectURLLink(
          '/cmsMismatchDetail',
          'CMS Mismatch Detail',
          history,
          dispatch
        );
        const indexOf = !_.isEmpty(arr)
          ? _.findIndex(arr, {
              field: 'cmsDetailsGrid',
              errorType: 'noDataforPerSelection',
            })
          : null;
        if (!_.isNull(indexOf) && indexOf >= 0) {
          arr.splice(indexOf, 1);
        }
      } else {
        setLoading(false);
        arr.push({
          field: 'cmsDetailsGrid',
          errorType: 'noDataforPerSelection',
          message: MNFC_NDC_ERROR_MSG,
        });
      }
    }
    const unique = [...new Set(arr)];
    dispatch(dispatchErrorMsg(unique));
  };
  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      }
    }
    if (type === 'quarter') {
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'quarter',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'quarter');
          setSearchData({
            ...searchData,
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
          setSearchCmsMismatch({
            searchData: {
              ...searchData,
              quarterValue: autoFormateDate(value?.toUpperCase()),
            },
          });
        } else {
          localErr = localErr.filter((item) => item.field !== 'quarter');
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: QUARTER_VALUE_REQUIRED,
        });
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsg(unique));
  };
  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther(navigate, true);
    } else {
      tabHighLigther(navigate, false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  // Rebate programe error on plan type change
  React.useEffect(() => {
    handleOnblurEvent('rebateProgramCd', '1');
  }, [searchData.planTypeCd]);
  return (
    <div
      className="tBillPanel custom-check tabs-container"
      data-testid="cms-mismatch-component"
    >
      <Spinner load={loading} />
      <CustomSeparator parent1="Research" parent2="CMS Mismatches" />
      {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={
            getErrorMsg?.length > 0 ? _.map(getErrorMsg, (l) => l.message) : []
          }
        />
      ) : null}
      <div className="tab-body">
        <div className="row mb-2">
          <div className="col-4 col-sm-6 col-md-5 col-lg-5 col-xl-4 frr-two-col-radio">
            <RadioGroupComponent
              data-testid="plan-type-data-cms-mismatch"
              id="plan-type-id-cms-mismatch"
              labelName={PLAN_TYPE}
              required
              optionList={radioList || []}
              defaultValue={searchData && searchData.planTypeCd}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'planTypeCd');
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-8 col-sm-6 col-md-7 col-lg-7 col-xl-8 mt-2 frr-cms-mismatch">
            <fieldset className="custom-fieldset">
              <legend aria-hidden="true" className="d-none" />
              <div className="form-wrapper flex-sm-column flex-md-row my-2">
                <div className="mui-custom-form with-select ">
                  <TextField
                    data-testid="rebate_program-cmsMismatch-rp"
                    id="rebate_program"
                    label={REBATE_PROGRAM}
                    className={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd'
                              ? 'mandate-fields'
                              : null
                          )
                        : null
                    }
                    fullWidth
                    select
                    required
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onBlur={(e) =>
                      handleOnblurEvent('rebateProgramCd', e.target.value)
                    }
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                    }
                    value={
                      searchData && searchData.rebateProgramCd
                        ? searchData.rebateProgramCd
                        : ''
                    }
                    error={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                    helperText={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                  >
                    <MenuItem
                      key=""
                      value=""
                      className="frr-dropdown-blank-item"
                    >
                      {''}
                    </MenuItem>
                    {rebateProgramList &&
                    rebateProgramList.length &&
                    rebateProgramList.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
                <div className="mui-custom-form input-md frr-check-invoice-quater">
                  <TextField
                    data-testid="check_quarter_cms_mismatch"
                    id="check_quarter_id_cms_mismatch"
                    required
                    label={QUARTER}
                    className={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'quarter' ? 'mandate-fields' : null
                          )
                        : null
                    }
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 6 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={
                      searchData && searchData.quarterValue
                        ? searchData.quarterValue
                        : ''
                    }
                    onBlur={(e) => handleOnblurEvent('quarter', e.target.value)}
                    onChange={(e) => {
                      handleOnChangeEvent(e.target.value, 'quarterValue');
                    }}
                    error={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'quarter' ? l.message : null
                          )
                        : null
                    }
                    helperText={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'quarter' ? l.message : null
                          )
                        : null
                    }
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-12 col-xl-4">
            <fieldset className="custom-fieldset w-100 customFormUi">
              <legend>
                Invoice Status <span className="mandatory"> *</span>
              </legend>

              <FormControlLabel
                // type="checkbox"
                className="mx-2 mr-4"
                id="mfginv-checkbox"
                data-testid="check_invoiced_id_cms_mismatch"
                label={INVOICED}
                control={<Checkbox color="primary" className="mr-2" />}
                checked={getCheckedValue?.invoiced === 1}
                onChange={() => {dispatch(dispatchErrorMsg([]))
                  if (getCheckedValue?.invoiced === 1) {
                    dispatch(
                      dispatchCheckedValueCMS({
                        ...checkValue,
                        invoiced: 0,
                      })
                    );
                  } else {
                    dispatch(
                      dispatchCheckedValueCMS({
                        ...checkValue,
                        invoiced: 1,
                      })
                    );
                  }
                }}
              />
              <FormControlLabel
                // type="checkbox"
                id="mfginv-deleate-checkbox"
                data-testid="check_nonInvoiced_id_cms_mismatch"
                label={NON_INVOICED}
                checked={getCheckedValue?.nonInvoiced === 1}
                control={<Checkbox color="primary" className="mr-2" />}
                onChange={() => {
                  dispatch(dispatchErrorMsg([]))
                  if (getCheckedValue?.nonInvoiced === 1) {
                    dispatch(
                      dispatchCheckedValueCMS({
                        ...checkValue,
                        nonInvoiced: 0,
                      })
                    );
                  } else {
                    dispatch(
                      dispatchCheckedValueCMS({
                        ...checkValue,
                        nonInvoiced: 1,
                      })
                    );
                  }
                }}
              />
            </fieldset>
          </div>
        </div>
      </div>
      <div className="row d-flex flex-row-reverse ">
        <div className="mx-4">
          <Button
            className="btn btn-success btn-save"
            data-testid="cms-mismatch-details-button"
            onClick={() => {
              clickHandlerOnProcess();
            }}
          >
            <SVGComponent iconName="Create-new-icon" />
            &nbsp;View CMS Mismatch
          </Button>
        </div>
      </div>
    </div>
  );
};
export default CmsMismatch;
